<template>
  <div class="main_div">
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1 class="f_l">발송 관리
          <button v-show="isEtners && !runModeIsProd" class="mid_btn" @click="demo('regi')" >
            <span>시연용(등기)</span>
          </button>
          <button v-show="isEtners && !runModeIsProd" class="mid_btn" @click="demo('express')" >
            <span>시연용(해외특송)</span>
          </button>
          <button v-show="isEtners && !runModeIsProd" class="mid_btn" @click="demo('deli')" >
            <span>시연용(택배)</span>
          </button>
        </h1>
        <div class="f_r" style="font-size:23px; line-height: 42px;">
          <button class="large_btn orange" style="width:100px; float:right; margin-left:10px;"
                  @click="onClickRefresh"
          > 새로고침
          </button>
          {{ lastRenderingTime }}
          <kendo-switch
              ref="autoYnRef"
              :messages-checked="'자동'"
              :messages-unchecked="'수동'"
              :checked="autoRender"
              @change="setAutoRender"
          >
          </kendo-switch>
        </div>
      </div>
      <div class="contents_wrap mg0">
        <div class="content_list">
          <div class="button_wrap_area">
            <ul>
              <li>
                <button class="large_btn orange" @click="commonOnChangeEvent">검색</button>
              </li>
              <li>
                <button class="large_btn" @click="cleanSearchDataEvent">초기화</button>
              </li>
            </ul>
          </div>
          <div id="filter_section" class="filter_wrap">
            <ul class="filter_list">
              <li class="col3">
                <dd>
                  <label>사업장</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          ref="facilityListRef"
                          :data-source="zone1DepthList"
                          :value="lastRouteParams.facility"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          class="w100"
                          @change="onChangeFacility"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>거점</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          ref="areaListRef"
                          :value="lastRouteParams.area"
                          :data-source="zone2DepthList"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          class="w100"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>발신</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          ref="sendNmRef"
                          id="sendNm"
                          :value="lastRouteParams.sendNm"
                          name="sendNm"
                          :style="'width: 100%'"
                          :placeholder="'발신/발송/사번 입력'"
                          class="w100"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
              </li>
              <li class="col3">
                <dd>
                  <label>등록일</label>
                  <ul>
                    <li>
                      <div class="fl k-widget k-daterangepicker k-state-default w100" data-role="daterangepicker"
                           role="combobox" aria-expanded="false" autocomplete="off">
                        <kendo-datepicker
                            ref="frstRgstDtRef"
                            :max="maxDate"
                            :placeholder="'년/월/일'"
                            :format="'yyyy/MM/dd'"
                            :value="lastRouteParams.frstRgstDt"
                            @change="commonOnChangeEvent"
                        >
                        </kendo-datepicker>
                        <span>&nbsp;</span>
                        <kendo-datepicker
                            ref="lastMdfyDtRef"
                            :max="maxDate"
                            :placeholder="'년/월/일'"
                            :format="'yyyy/MM/dd'"
                            :value="lastRouteParams.lastMdfyDt"
                            @change="commonOnChangeEvent"
                        >
                        </kendo-datepicker>
                      </div>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>운송장 번호</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          ref="blNoRef"
                          id="blNo"
                          :style="'width: 100%'"
                          :placeholder="'송장 번호 입력'"
                          :value="lastRouteParams.blNo"
                          class="w100"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>수신</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          ref="ReceiveRef"
                          id="receiveNm"
                          :style="'width: 100%'"
                          :placeholder="'수신 입력'"
                          :value="lastRouteParams.receiveNm"
                          class="w100"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
              </li>
              <li class="col3">
                <dd>
                  <label>용도</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="ppsScnRef"
                          :index="computedPpsScn"
                          @select="commonOnChangeEvent"
                          :style="{width: '100%', border: '0'}"
                      >
                        <kendo-buttongroup-button
                            v-for="item in ['전체', '개인용', '업무용']"
                            :key="item"
                        >
                          {{ item }}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>취급 구분</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="sendScnRef"
                          @select="commonOnChangeEvent"
                          :style="{width: '100%', border: '0'}"
                          :data-source="sendScnList"
                          :index="computedSendScn"
                      >
                        <kendo-buttongroup-button
                            v-for="item in sendScnList"
                            :key="item.cdId">
                          {{item.cdNm}}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>특송사</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          ref="shpcScnListRef"
                          :data-source="sendShpcScnList"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :style="'width: 100%;'"
                          :value="lastRouteParams.shpcScn"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ul class="tab mgt30">
        <li v-for="item in [{cdNm:'전체', cdId: undefined}, ...sendStatusList]"
            :class="{on : (lastRouteParams.status === item.cdId)}"
            @click="$set(lastRouteParams, 'status', item.cdId); commonOnChangeEvent()">
        {{ item.cdNm }}
        </li>
      </ul>
      <div class="dblock mgt20">
        <div class="c_t_button_wrap f_l">
          <button class="mid_btn mr5" @click="redirectToSave('01')"><span style="vertical-align: middle;"><span
              class="k-icon k-i-plus"></span>등기 등록</span></button>
          <button class="mid_btn mr5" @click="redirectToSave('03')"><span style="vertical-align: middle;"><span
              class="k-icon k-i-plus"></span>해외 특송 등록</span></button>
          <button class="mid_btn mr5" @click="redirectToSave('02')"><span style="vertical-align: middle;"><span
              class="k-icon k-i-plus"></span>택배 등록</span></button>

          <button class="mid_btn mr5" :disabled="!(lastRouteParams.status==='02' || lastRouteParams.status===undefined)" @click="onClickBatchUpdate"><span style="vertical-align: middle;">배송사 전달</span></button>
          <div class="f_r mgl10" v-if="lastRouteParams.status === '00'">
            <kendo-switch
                ref="autoYnRef"
                :messages-checked="'On'"
                :messages-unchecked="'Off'"
                :checked="includeCancelYn === 'Y'"
                @change="includeCancelYn = (includeCancelYn === 'Y' ? 'N' : 'Y'); commonOnChangeEvent();"
            >
            </kendo-switch>
              예약 취소 상태 표시하기
          </div>
        </div>

        <div class="c_t_button_wrap fr">
          <button v-if="isSU" class="mid_btn mr5" @click="$refs.selectSendScnWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()">
            <i class="download_icon"></i>
            <span>대량 저장</span>
          </button>
          <button v-if="isSU" class="mid_btn mr5" @click="onClickExcelUpload">
            <i class="download_icon"></i>
            <span>엑셀 업로드</span>
          </button>
          <button class="mid_btn mr5" @click="onClickExcelDownload">
            <i class="download_icon"></i>
            <span>엑셀 다운로드</span>
          </button>
        </div>
      </div>
      <kendo-grid ref="sendGridRef"
                  style="cursor: pointer;"
                  class="basic_table mt10"
                  :data-source="sendListDataSource"
                  :columns="sendListColumns"
                  :navigatable="true"
                  :filterable="false"
                  :sortable="true"
                  :scrollable="true"
                  :pageable-always-visible="true"
                  :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
                  :reorderable="true"
                  :column-menu="false"
                  :resizable="true"
                  :selectable="'multiple row'"
                  @change="onChangeGrid"
                  :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
      </kendo-grid>
    </section>

    <required-info-for-regi
        ref="regiRequiredInfoWindowRef"
        :title="'필요 정보 기입'"
        :sendInfo="sendInfo"
        @getInfoForRegi="getStatusUpdateData"
    >
    </required-info-for-regi>
    <required-info-for-deli
        ref="deliRequiredInfoWindowRef"
        :title="'필요 정보 기입'"
        :propsSendInfo="sendInfo"
        @getInfoForDeli="getExtraInfo"
    ></required-info-for-deli>

    <send-excel-upload-window
        ref="sendExcelUploadWindowRef"
        @onChange="commonOnChangeEvent"
    ></send-excel-upload-window>
    <select-send-scn-window
        ref="selectSendScnWindowRef"
        @onSelect="redirectToBundleSave"
    ></select-send-scn-window>
  </div>
</template>
<script>

import ApiConfig from "@/api/api.config";
import EtnersDateTimeUtil from "@/common/etners.datetime.util";
import EtnersParseUtil from "@/common/etners.parse.util";
import $ from "jquery";
import ApiUtil from "@/api/api.util";
import EtnersCommonUtil from "@/common/etners.common.util";
import {saveExcel} from "@progress/kendo-vue-excel-export";
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";

import RequiredInfoForRegi from "@/components/send/RequiredInfoForRegi";
import RequiredInfoForDeli from "@/components/send/RequiredInfoForDeli";
import ContactInfoWindow from "@/components/send/ContactInfoWindow";
import SendExcelUploadWindow from "@/components/send/SendExcelUploadWindow";
import SelectSendScnWindow from "@/components/send/SelectSendScnWindow";
import EtnersLogisticsUtil from '@/common/etners.logistics.util'

export default {
  name: 'ManageSendList',
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  components: {RequiredInfoForRegi, RequiredInfoForDeli, ContactInfoWindow, SendExcelUploadWindow, SelectSendScnWindow},
  beforeMount() {
    const vm = this
    const jsonStrLastRouteParams = sessionStorage.getItem('LAST_ROUTE_PARAMS')
    vm.lastRouteParams = sessionStorage.getItem('LAST_ROUTE_NAME') === 'SendDetail' ? (jsonStrLastRouteParams === undefined ? [] : JSON.parse(jsonStrLastRouteParams)) : []
  },
  mounted() {
    const vm = this
    // 그리드 데이터
    vm.settingDefault()
    vm.$refs.lastMdfyDtRef.kendoWidget().value(vm.maxDate)

    //엔터키 이벤트 자동 세팅
    const enterkeyEventTargetIdArray = [
      'sendNm', 'blNo', 'receiveNm'
    ]

    for (const elementId of enterkeyEventTargetIdArray) {
      const element = document.getElementById(elementId)
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 'Enter'
          const NUM_PAD_ENTER = 'NumpadEnter'
          const currentKeyCode = e.code

          if (currentKeyCode === ENTER_KEY_CODE || currentKeyCode === NUM_PAD_ENTER) {
            vm.commonOnChangeEvent(e)
          }
        }
      }
    }
  },
  computed: {
    computedPpsScn() {
      const vm = this
      const ppsScn = vm.lastRouteParams.ppsScn
      if (ppsScn === undefined || ppsScn === null) {
        return 0
      } else {
        if (ppsScn === '01') {
          return 1
        } else if (ppsScn === '02') {
          return 2
        } else {
          return 0
        }
      }
    },
    computedSendScn () {
      const vm = this
      const sendScn = vm.lastRouteParams.sendScn
      if (sendScn === undefined || sendScn === null) {
        return 0
      } else {
        if (sendScn === '01') {
          return 1
        } else if (sendScn === '02') {
          return 2
        } else if (sendScn === '03') {
          return 3
        } else {
          return 0
        }
      }
    }
  },
  methods: {
    setAutoRender() {
      const vm = this
      vm.autoRender = !vm.autoRender
      if (vm.autoRender) {
        vm.intervalSetting = window.setInterval(() => {
              vm.commonOnChangeEvent()
              vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(new Date())
            }, 300000
        );
      } else {
        window.clearInterval(vm.intervalSetting);
      }
    },
    getSendList: function () {
      const vm = this
      const lastRequestParameterPage = vm.lastRouteParams.page !== undefined ? vm.lastRouteParams.page : 1
      const lastRequestParameterPageSize = vm.lastRouteParams.pageSize !== undefined ? vm.lastRouteParams.pageSize : 10
      vm.sendListDataSource = new kendo.data.DataSource({
        name: 'sendListDataSource',
        page: lastRequestParameterPage,
        pageSize: lastRequestParameterPageSize,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendList.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },

          parameterMap: function (options, operation) {
            if (operation === 'read') {
              const paramToKendoFilters = vm.currentPageFilterOption()
              const params = {
                loginUserToken: vm.loginUserToken,
                skip: options.skip,
                take: options.take,
                sort: options.sort,
                page: options.page,
                pageSize: options.pageSize,
                ...paramToKendoFilters,
                requestType: 'PAGING',
              }

              sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(params))
              return kendo.stringify(params)
            }

            if (operation !== 'read' && options.models) {
              return {models: kendo.stringify(options.models)}
            }
          }
        },
        schema: {
          type: 'json',
          parse: function (response) {

            if (response.resultStatus.messageCode !== '2000') {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }

            const changeResultData = response.resultData
            let rowNumber = response.total > 1 ? response.total - ((vm.$refs.sendGridRef
                .dataSource.page() - 1) * vm.$refs.sendGridRef.dataSource.pageSize()) : response.total
            if (changeResultData === null) {
              return false
            }
            for (let i = 0; i < changeResultData.length; i++) {
              const row = changeResultData[i]
              // row 번호 내림차순 셋팅
              row.rowNumber = rowNumber--
            }
            //status 상태 값 받아오기
            response.resultData = changeResultData
            return response
          },
          total: function (response) {
            return response.total
          },
          data: function (response) {
            // 카테고리 seq 순으로 배열 선언
            if (response.resultStatus.messageCode === '2000') {
              return response.resultData
            } else {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
          }
        },
        error: function (e) {
          // console.log('error event handler', e.errors)
        }
      })
    },
    onClickRefresh() {
      const vm = this
      vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(
          new Date()
      );
      vm.$emit('refreshAll', true)
      vm.commonOnChangeEvent()
    },
    currentPageFilterOption: function () {
      const vm = this
      const refs = vm.$refs
      const currentSearchDataObj = {}

      //사업장
      if (refs.facilityListRef !== undefined) {
        const facilityId = refs.facilityListRef.kendoWidget().value()
        if (facilityId !== undefined && facilityId !== '') {
          currentSearchDataObj.facility = facilityId
        }
      }
      //거점
      if (refs.areaListRef !== undefined) {
        const areaId = refs.areaListRef.kendoWidget().value()
        if (areaId !== undefined && areaId !== '') {
          currentSearchDataObj.area = areaId
        }
      }
      //발신
      if (refs.sendNmRef !== undefined) {
        const sendNmId = refs.sendNmRef.kendoWidget().value().trim()
        if (sendNmId !== undefined && sendNmId !== '') {
          currentSearchDataObj.sendNm = sendNmId
        }
      }
      //등록일 (start)
      if (refs.frstRgstDtRef !== undefined) {
        const frstRgsDt = refs.frstRgstDtRef.kendoWidget().value()
        if (frstRgsDt !== undefined && frstRgsDt !== '' && frstRgsDt !== null) {
          currentSearchDataObj.frstRgstDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(frstRgsDt, '/')
        }
      }
      //둥록일 (End)
      if (refs.lastMdfyDtRef !== undefined) {
        const lastMdfyDt = refs.lastMdfyDtRef.kendoWidget().value()
        if (lastMdfyDt !== undefined && lastMdfyDt !== '' && lastMdfyDt !== null) {
          currentSearchDataObj.lastMdfyDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(lastMdfyDt, '/')
        }
      }
      //bLNO (바코드 이름)
      if (refs.blNoRef !== undefined) {
        const blNo = refs.blNoRef.kendoWidget().value().trim()
        if (blNo !== undefined && blNo !== '') {
          currentSearchDataObj.blNo = blNo
        }
      }
      //수신
      if (refs.ReceiveRef !== undefined) {
        const receiveNm = refs.ReceiveRef.kendoWidget().value().trim()
        if (receiveNm !== undefined && receiveNm !== '') {
          currentSearchDataObj.receiveNm = receiveNm
        }
      }
      //용도 (보류)
      if (refs.ppsScnRef !== undefined) {
        const ppsScn = refs.ppsScnRef.kendoWidget().current().index()
        if (ppsScn !== '' && ppsScn !== null) {
          let resultPpsScn
          if (ppsScn === 0) {
            resultPpsScn = ''
          } else if (ppsScn === 1) {
            resultPpsScn = '01'
          } else if (ppsScn === 2) {
            resultPpsScn = '02'
          }
          currentSearchDataObj.ppsScn = resultPpsScn
        }
      }
      //취급구분
      if (refs.sendScnRef !== undefined) {
        const sendScnId = refs.sendScnRef.kendoWidget().current().index()
        if (sendScnId !== '' && sendScnId !== null) {
          let resultsendScnId
          if (sendScnId === 0) {
            resultsendScnId = ''
          } else if (sendScnId === 1) {
            resultsendScnId = '01'
          } else if (sendScnId === 2) {
            resultsendScnId = '02'
          }else if (sendScnId === 3) {
            resultsendScnId = '03'
          }
          currentSearchDataObj.sendScn = resultsendScnId
        }
      }
      //특송사
      if (refs.shpcScnListRef !== undefined) {
        const shpcScnId = refs.shpcScnListRef.kendoWidget().value()
        if (shpcScnId !== undefined && shpcScnId !== '') {
          currentSearchDataObj.shpcScn = shpcScnId
        }
      }
      //상태 탭
      currentSearchDataObj.status = vm.lastRouteParams.status
      currentSearchDataObj.includeCancelYn = vm.includeCancelYn

      return currentSearchDataObj.length === 0 ? undefined : currentSearchDataObj
    },
    onChangeFacility: function (e) {
      const vm = this
      vm.$refs.areaListRef.kendoWidget().value(null)
      vm.onChange1Depth('facilityListRef')
      vm.commonOnChangeEvent()
    },
    commonOnChangeEvent: function (e) {
      const vm = this
      const gridRefs = this.$refs.sendGridRef
      if (gridRefs !== undefined && gridRefs.kendoWidget() !== undefined) {
        if (vm.lastRouteParams.page === undefined) {
          gridRefs.kendoWidget().dataSource.page(1)
        } else {
          gridRefs.kendoWidget().dataSource.read()
          this.lastRouteParams.page = undefined
        }
      }
    },
    cleanSearchDataEvent: function (e) {
      const vm = this
      const refs = this.$refs

      if (refs.facilityListRef !== undefined) {
        refs.facilityListRef.kendoWidget().value('')
      }
      if (refs.areaListRef !== undefined) {
        refs.areaListRef.kendoWidget().value('')
      }
      if (refs.sendNmRef !== undefined) {
        refs.sendNmRef.kendoWidget().value('')
      }
      if (refs.frstRgstDtRef !== undefined) {
        refs.frstRgstDtRef.kendoWidget().value('')
      }
      if (refs.lastMdfyDtRef !== undefined) {
        refs.lastMdfyDtRef.kendoWidget().value('')
      }
      if (refs.blNoRef !== undefined) {
        refs.blNoRef.kendoWidget().value('')
      }
      if (refs.ReceiveRef !== undefined) {
        refs.ReceiveRef.kendoWidget().value('')
      }
      if (refs.shpcScnListRef !== undefined) {
        refs.shpcScnListRef.kendoWidget().value('')
      }
      if (refs.sendScnRef !== undefined) {
        refs.sendScnRef.kendoWidget().select(0)
      }
      if (refs.ppsScnRef !== undefined) {
        refs.ppsScnRef.kendoWidget().select(0)
      }
      vm.lastRouteParams.status = undefined

      vm.commonOnChangeEvent()
    },
    onClickExcelUpload () {
      this.$refs.sendExcelUploadWindowRef.$refs.kendoWindowRef
          .kendoWidget()
          .center()
          .open()
    },
    onClickExcelDownload () {
      const lastRequestParameters = JSON.parse(sessionStorage.getItem('LAST_ROUTE_PARAMS'))
      const excelParams = JSON.parse(JSON.stringify(lastRequestParameters))

      excelParams.requestType = 'EXPORT'
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendList.json`
      ApiUtil.post(url, excelParams).then(response => {
        let changeResultData = response.data.resultData
        if (EtnersCommonUtil.isNotEmpty(changeResultData)) {

          const currentDate = EtnersDateTimeUtil.lookupDateYYYYMMDD()
          const currentYYYYMMDD = EtnersDateTimeUtil.dateToYYYYMMDD(currentDate)

          saveExcel({
            data: changeResultData,
            fileName: `발송관리_${currentYYYYMMDD}.xlsx`,
            columns: [
              {field: 'frstRgstDt', title: '등록일시', width: '100px',},
              {field: 'facilityNm', title: '사업장', width: '100px',},
              {field: 'areaNm', title: '거점', width: '100px',},
              {field: 'ppsScn', title: '용도', width: '100px',},
              {field: 'sendScnNm', title: '취급 구분', width: '100px',},
              {field: 'shpcScn', title: '특송사', width: '100px',},
              {field: 'blNo', title: '운송장 번호', width: '100px',},
              {field: 'sendNm', title: '발신', width: '100px',},
              {field: 'sendDept', title: '발신 부서', width: '100px',},
              {field: 'steadNm', title: '발송인', width: '100px',},
              {field: 'receiveNm', title: '수신', width: '100px',},
              {field: 'path', title: '접수 경로', width: '100px',},
              {field: 'statusNm', title: '진행 상태', width: '100px',},
              {field: 'frstRgstId', title: '최초 등록자', width: '100px',},
              {field: 'lastMdfyDt', title: '마지막 수정일시', width: '100px',},
              {field: 'lastMdfyId', title: '마지막 수정자', width: '100px',},
            ]
          })
        } else {
          kendo.alert('다운로드 할 자료가 없습니다.')
        }
      })

    },
    onChangeGrid(e) {
      if (!([0].includes(e.sender._lastCellIndex))) {
        const selectedRow = e.sender.select()
        const item = e.sender.dataItem(selectedRow)

        this.$router.push({
          name: 'SendDetail',
          params: {
            sendId: item.sendId
          },
        })
      }
    },
    redirectToSave (sendScnNm) {
      this.$router.push({
        name: 'SendSave',
        params: {
          sendScn: sendScnNm
        }
      })
    },
    settingDefault(){
      const vm = this
      const facility = vm.loginUserData.facility
      const area = vm.loginUserData.area
      //사업장
      vm.$refs.facilityListRef.kendoWidget().value(facility)
      vm.onChange1Depth('facilityListRef')
      //거점
      vm.$refs.areaListRef.kendoWidget().setDataSource(vm.zone2DepthList)
      vm.$refs.areaListRef.kendoWidget().value(area)

      vm.getSendList()
    },
    onClickBatchUpdate () {
      const vm = this
      const selectedRows = vm.$refs.sendGridRef.kendoWidget().select()
      if (selectedRows.length === 0) {
        kendo.alert(`배송사 전달로 진행할 건을 선택해주세요.`)
        return
      }

      // 일괄 완료 처리 대상
      let batchList = []
      let firstSendScn = ''
      for (let selectedRowValue of selectedRows) {
        const row = vm.$refs.sendGridRef.kendoWidget().dataItem(selectedRowValue)
        if (!vm.isSU && row.facility !== vm.loginUserData.facility) {
          kendo.alert('소속된 사업장의 물품만 상태변경 가능합니다.')
          return
        }
        if (EtnersCommonUtil.isNotEmpty(firstSendScn) && firstSendScn !== row.sendScn) {
          kendo.alert("일괄 배송사 전달은 같은 발송 유형에 대해서만 가능합니다.")
          return
        }
        if (row.status !== '02') {
          kendo.alert("배송사 전달 처리는 물품 접수 상태인 물품만 가능합니다.")
          return
        }
        if (row.status === '02' && row.requiredInfoYn !== 'Y') {
          kendo.alert("배송사 전달 처리를 위해 필요 정보를 기입해주세요.")
          return
        }
        batchList.push(row.sendId)
        firstSendScn = row.sendScn
      }

      kendo.confirm(`총 <b>${batchList.length}</b>건의 발송을 <b>배송사 전달</b> 처리 하시겠습니까?`).done(() => {
        if (firstSendScn === '02') {
          // 택배(02) : 일양 api 호출
          vm.callIlyangApi(batchList).then((resultData) => {
            const successIdList = resultData.successIdList
            vm.callBatchUpdateApi(successIdList)
          })
        } else {
          vm.callBatchUpdateApi(batchList)
        }
      })
    },
    callIlyangApi (batchList) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/ilyangLogis.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        runTimeMode: (process.env.NODE_ENV === 'production') ? 'PROD' : 'DEV',
        sendIdList: batchList,
      }

      return new Promise((resolve, reject) => {
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            reject()
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            reject()
          }
          const resultData = response.data.resultData
          resolve(resultData)
        })
      })
    },
    callBatchUpdateApi (batchList) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/batchUpdateStatus.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        sendIdList: batchList
      }
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
        }
        const resultData = response.data.resultData
        kendo.alert(`${resultData} 건이 배송사 전달 처리 되었습니다.`)
        vm.commonOnChangeEvent()
      })
    },
    getSendDetail (sendId) {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: sendId,
      }
      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendDetail.json`
      return new Promise((resolve, reject) => {
        ApiUtil.post(jsonUrl, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            reject()
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            reject()
          }
          vm.sendInfo = response.data.resultData // props 세팅
          resolve()
        })
      })
    },
    getStatusUpdateData (blNo, regCost, sendMailAddr) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/updateRequiredInfo.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.sendInfo.sendId,
        blNo: blNo,
        regCost: regCost,
        sendMailAddr: sendMailAddr
      }
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        kendo.alert('업데이트 되었습니다.')
        vm.commonOnChangeEvent()
      })
    },
    getExtraInfo (weight, sendMailAddr) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/updateRequiredInfo.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.sendInfo.sendId,
        weight: weight,
        sendMailAddr: sendMailAddr,
      }

      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false

        }
        kendo.alert('업데이트 되었습니다.')
        vm.commonOnChangeEvent()
      })
    },
    getMailAddr (info) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/updateRequiredInfo.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.sendInfo.sendId,
        sendMailAddr: info.sendMailAddr,
      }
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        kendo.alert('업데이트 되었습니다.')
        vm.commonOnChangeEvent()
      })
    },
    redirectToBundleSave(sendScn) {
      this.$router.push({name: 'SendBundleSave', params: {sendScn: sendScn}})
    },

    demo(type){
      const vm = this
      const regi = {
        blNo: null,
        contentsScn: "01",
        deliveryScn: "02",
        itemNm: null,
        ppsScn: "02",
        qty: null,
        receiveAddr: "경기 과천시 과천대로7나길 60 (갈현동, 과천어반허브)",
        receiveAddrDtl: "5층 이트너스",
        receiveNm: "김등기",
        receivePost: "13840",
        receiveTel: "01000000000",
        regCost: null,
        sendDept: "연구소",
        sendMailAddr: "choetruth@etners.com",
        sendNm: "손석희",
        sendSabun: "66790619",
        sendScn: "01",
        sendScnNm: "등기",
        sendTel: "01000000000",
        shpcScn: "05",
        shpcScnNm: "우체국",
        status: "00",
        statusNm: "예약",
        steadDept: "연구소",
        steadMailAddr: "choetruth@etners.com",
        steadNm:"손석희",
        steadTel: "01000000000",
        steadYn: "N",
        woodenYn: "N"
      }

      const deli = {
        blNo: null,
        contentsScn: "01",
        deliveryScn: "02",
        itemNm: "택배",
        ppsScn: "02",
        qty: "1",
        receiveAddr: "경기 과천시 과천대로7나길 60 (갈현동, 과천어반허브)",
        receiveAddrDtl: "5층 이트너스",
        receiveNm: "김택배",
        receivePost: "13840",
        receiveTel: "01000000000",
        regCost: "5000",
        sendDept: "연구소",
        sendMailAddr: "choetruth@etners.com",
        sendNm: "손석희",
        sendSabun: "66790619",
        sendScn: "02",
        sendScnNm: "택배",
        sendTel: "01000000000",
        shpcScn: "04",
        shpcScnNm: "일양택배",
        status: "00",
        statusNm: "예약",
        steadDept: "연구소",
        steadMailAddr: "choetruth@etners.com",
        steadNm: "손석희",
        steadTel: "01000000000",
        steadYn: "N",
        woodenYn: "N"
      }

      const express ={
        blNo: "2024071015",
        contentsScn: "01",
        deliveryScn: "02",
        itemNm: null,
        ppsScn: "02",
        qty: 1,
        receiveAddr: null,
        receiveAddrDtl: null,
        receiveNm: null,
        receivePost: null,
        receiveTel: null,
        regCost: null,
        sendDept: "연구소",
        sendMailAddr: "choetruth@etners.com",
        sendNm: "손석희",
        sendSabun: "66790619",
        sendScn: "03",
        sendScnNm: "해외특송",
        sendTel: "01000000000",
        shpcScn: "01",
        shpcScnNm: "DHL",
        status: "00",
        statusNm: "예약",
        steadDept: "연구소",
        steadMailAddr: "choetruth@etners.com",
        steadNm:"손석희",
        steadTel: "01000000000",
        steadYn: "N",
        woodenYn: "Y"
      }

      const reserveSendInfo = type === 'regi' ? regi : type === 'deli' ? deli : express
      const param = {
        loginUserToken: vm.loginUserToken,
        reserveSendInfo: reserveSendInfo
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/reserveSend/sendReserveSave.json`
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const sendId = response.data.resultData

        kendo.alert('시연용 데이터 정상 입력 : ' + sendId)
      })
    },

  },
  data: function () {
    const vm = this
    const now = new Date()
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    const kendoGridBodyAttributes = {
      class: 'tcenter k-text-ellipsis',
    }
    const loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
    const isSU = loginUserData.authId === '9999'
    return {
      isEtners : JSON.parse(sessionStorage.getItem('loginUserData')).authId === '9999' ? true : false,
      runModeIsProd : process.env.NODE_ENV === 'production' ? true : false, // production, development, local

      autoRender: false,
      isRefresh: true,
      refreshEvent: undefined,
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      isSU: isSU,
      lastRouteParams: [],
      lastRenderingTime: EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(now),
      sendListDataSource: [],
      includeCancelYn: 'Y',
      maxDate : now,

      sendListColumns: [
        {
          title: '전체선택',
          selectable: "true",
          width: "3%",
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'frstRgstDt',
          title: '등록일시',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'facilityNm',
          title: '사업장',
          width: '7%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.facilityNm)
          }
        },
        {
          field: 'areaNm',
          title: '거점',
          width: '7%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.areaNm)
          }
        },
        {
          field: 'ppsScn',
          title: '용도',
          width: '4%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendScnNm',
          title: '취급 구분',
          width: '5%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'shpcScn',
          title: '특송사',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'blNo',
          title: '운송장 번호',
          width: '9%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.blNo)
          }
        },
        {
          field: 'sendNm',
          title: '발신',
          width: '6%',
          headerAttributes : {
            'class': 'bg_green',
          },
          attributes: kendoGridBodyAttributes,
        },
        {
          field: 'sendDept',
          title: '발신 부서',
          width: '9%',
          headerAttributes : {
            'class': 'bg_green',
          },
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.sendDept)
          }
         },
          {
          field: 'steadNm',
          title: '발송인',
          width: '6%',
          headerAttributes : {
            'class': 'bg_green',
          },
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            let res = EtnersParseUtil.convertEmptyStringToSeparator(dataItem.steadNm)
            if (dataItem.steadYn === 'Y') {
              res = `<b>[대리]</b>${dataItem.steadNm} `
            }
            return res
          }
        },
        {
          field: 'receiveNm',
          title: '수신',
          width: '7%',
          headerAttributes : {
            'class': 'bg_blue',
          },
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.receiveNm)
          }
        },
        {
          field: 'requiredInfoYn',
          title: '필수 정보',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template (dataItem) {
            return dataItem.requiredInfoYn
          },
          command: [
            {
              name: '수정',
              template: `<a class="k-grid-수정 pd0"><button class="btn mid_btn green" style="margin-top:-5px">입력하기</button></a>`,
              click: function (e) {
                e.preventDefault()
                let tr = $(e.target).closest('tr')
                const selectedRow = this.dataItem(tr)
                if(!vm.isSU && selectedRow.facility !== vm.loginUserData.facility){
                  kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
                  return
                }
                vm.getSendDetail(selectedRow.sendId).then(() => {
                  const sendScn = selectedRow.sendScn
                  if (sendScn === '01') {
                    vm.$refs.regiRequiredInfoWindowRef.$refs.kendoWindowRef.kendoWidget().open().center()
                  } else if (sendScn === '02') {
                    vm.$refs.deliRequiredInfoWindowRef.$refs.kendoWindowRef.kendoWidget().open().center()
                  }
                })
              },
              visible (dataItem) {
                const status = dataItem.status
                return (dataItem.requiredInfoYn === 'N') && (status === '01' || status === '02' || status === '04')
              },
            },
            {
              name: "empty",
              template: kendo.template(`<a class='k-grid-empty'>완료</a>`),
              visible: function (dataItem) {
                const status = dataItem.status
                return (dataItem.requiredInfoYn === 'Y') && (status === '01' || status === '02' || status === '04' || status === '99')
              }
            },
            {
              name: "empty",
              template: kendo.template(`<a class='k-grid-empty'>입력불가</a>`),
              visible: function (dataItem) {
                return dataItem.requiredInfoYn === '-'
              }
            }
          ]
        },
        {
          field: 'path',
          title: '접수 경로',
          width: '7%',
          headerAttributes : kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'statusNm',
          title: '진행 상태',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            let statusNm = EtnersParseUtil.convertEmptyStringToSeparator(dataItem.statusNm)
            if(dataItem.status === '00'){
              return `<span class='process03 process_icon'>${statusNm}</span>`
            } else if (dataItem.status === '01') {
              return `<span class='process01 process_icon'>${statusNm}</span>`
            } else if(dataItem.status === '02'){
              return `<span class='process02 process_icon'>${statusNm}</span>`
            } else if(dataItem.status === '04'){
              return `<span class='process03 process_icon'>${statusNm}</span>`
            } else if(dataItem.status === '05'){
              return `<span class='process04 process_icon'>${statusNm}</span>`
            } else if(dataItem.status === '98'){
              return `<span class='process07 process_icon'>${statusNm}</span>`
            } else if(dataItem.status === '99'){
              return `<span class='process08 process_icon'>${statusNm}</span>`
            }
          }
        },
      ],
      sendInfo: {}
    }
  }
}

</script>
